<template>
    <section class="section posted-by-page">
        <div class="container">
            <h2><small>Adverts posted by</small><br>
                {{ pageState.user.public_name }}
            </h2>

            <div class="myads__header">
                <ul class="tabs-nav">
                    <li :class="{ 'active': !['rent-property', 'rent-room', 'want-room'].includes(adType) }">
                        <a :href="`/adverts/posted-by/${pageState.user.slug}`">
                            All ({{ pageState.totals['all'] }})
                        </a>
                    </li>
                    <li :class="{ 'active': adType === 'rent-property' }" v-if="pageState.totals['rent-property'] > 0">
                        <a :href="`/adverts/posted-by/${pageState.user.slug}/rent-property`">
                            Property to rent ({{ pageState.totals['rent-property'] }})
                        </a>
                    </li>
                    <li :class="{ 'active': adType === 'rent-room' }" v-if="pageState.totals['rent-room'] > 0">
                        <a :href="`/adverts/posted-by/${pageState.user.slug}/rent-room`">
                            Room to rent ({{ pageState.totals['rent-room'] }})
                        </a>
                    </li>
                    <li :class="{ 'active': adType === 'want-room' }" v-if="pageState.totals['want-room'] > 0">
                        <a :href="`/adverts/posted-by/${pageState.user.slug}/want-room`">
                            Want Property/Room ({{ pageState.totals['want-room'] }})
                        </a>
                    </li>
                </ul>
            </div>

            <div class="row">
                <div class="advert__right mt-3 less-tablet-only">
                    <UserCardDetails :user="pageState.user" :hide-call="false"
                        :disable-call="user && user.uuid === pageState.user.uuid"
                        :disable-chat="true"
                        :hide-chat="true" />
                    <UserCardDetails v-if="pageState.user.is_agent" :user="pageState.user.company" :hide-call="true"
                        :disable-call="user && user.uuid === pageState.user.uuid" :disable-chat="true"
                        :hide-chat="true" />
                </div>
                <div class="col-md-8 col-lg-9">
                    <div class="my-adverts posted-by">
                        <div class="my-adverts__content" v-if="!pageState.data.length">
                            <p>No posted adverts</p>
                        </div>

                        <div class="my-adverts__content" v-else>
                            <AdCard v-for="advert in pageState.data" :ad="advert" :key="advert.slug" />

                            <BPagination v-if="pageState.recordsTotal > pageState.length" :value="pageState.currentPage"
                                :total-rows="pageState.recordsTotal" :per-page="pageState.length" limit="7"
                                @page-click="onChangePage" />
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-lg-3 over-tablet-only">
                    <div class="advert__right">
                        <UserCardDetails :user="pageState.user" :hide-call="false"
                            :disable-call="user && user.uuid === pageState.user.uuid"
                            :disable-chat="true"
                            :hide-chat="true" />
                        <UserCardDetails v-if="pageState.user.is_agent" :user="pageState.user.company" :hide-call="true"
                            :disable-call="user && user.uuid === pageState.user.uuid" :disable-chat="true"
                            :hide-chat="true" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from 'vuex';
import { BPagination } from 'bootstrap-vue';
import { redirectTo } from '@helpers/url-handler';
import AdCard from '@/components/AdCard/AdCard.vue';
import UserCardDetails from '@/components/AdDetails/partials/UserCardDetails.vue';

export default {
    components: {
        AdCard,
        BPagination,
        UserCardDetails,
    },
    computed: {
        ...mapState(['pageState']),
        ...mapState('user', ['user']),
        adType() {
            const url = new URL(window.location.href);
            const segments = url.pathname.split('/');
            return segments[segments.length - 1];
        },
    },
    methods: {
        onChangePage(bvEvent, page) {
            const start = (page - 1) * this.pageState.length;
            redirectTo(window.location.pathname, { start });
        },
    },
};
</script>
